import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import './CTASection.scss';

const CTASection = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.2, rootMargin: '0px' }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <section
            className={`rtx-cta-section ${isVisible ? 'rtx-visible' : ''}`}
            ref={sectionRef}
        >
            <Container>
                <Row className="justify-content-center">
                    <Col lg="10" md="10" className="text-center">
                        <div className="rtx-cta-content">
                            <h1 className={`title ${isVisible ? 'rtx-animated-title' : ''}`}>
                                Ready to Scale Your Digital Performance?
                            </h1>

                            <h3 className={`subtitle ${isVisible ? 'rtx-animated-text' : ''}`}>
                                Book a free strategy call and discover how Reachtix can help you grow profitably.
                            </h3>

                            <div className={`gb-cta-wrapper ${isVisible ? 'gb-animated' : ''}`}>
                                <Link to='contact' className="cta-button-info">
                                    Book a Free Strategy Call
                                    <span className="gb-cta-arrow">→</span>
                                </Link>
                            </div>

                            <div className={`rtx-cta-metrics ${isVisible ? 'rtx-animated-metrics' : ''}`}>
                                <div className="rtx-metric-item">
                                    <div className="rtx-metric-number">30-min</div>
                                    <div className="rtx-metric-label">Free Session</div>
                                </div>
                                <div className="rtx-metric-item">
                                    <div className="rtx-metric-number">£0</div>
                                    <div className="rtx-metric-label">No Setup Fees</div>
                                </div>
                                <div className="rtx-metric-item">
                                    <div className="rtx-metric-number">24h</div>
                                    <div className="rtx-metric-label">Quick Start</div>
                                </div>
                            </div>

                            <div className={`rtx-cta-note ${isVisible ? 'rtx-animated-note' : ''}`}>
                                <p className="rtx-note-text">
                                    <i className="fas fa-check-circle me-2"></i>
                                    No commitment • Tailored recommendations • Performance-driven results
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default CTASection;